import React from "react";
import Navbar from "./components/Navbar/Navbar";
import { BrowserRouter as Router, Routes, Route, Navigate, BrowserRouter } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import BusinessServices from './pages/BusinessServices/BusinessServices';
import CampaignFinance from './pages/CampaignFinance/CampaignFinance';
import ElectionData from './pages/ElectionData/ElectionData';
import VoterRegistration from './pages/VoterRegistration/VoterRegistration';
import LandingPage from './pages/LandingPage/LandingPage';
import HistoricalComparisons from './pages/HistoricalComparisons/HistoricalComparisons'
import ElectionResults from "./pages/ElectionResults/ElectionResults";



function App() {
    return (
    <BrowserRouter basename="/portal">
      <main style={{ minHeight: '80vh' }}>
        <Routes>
          <Route path="/" element={<Navigate to="/voter-registration" replace/>}/>
          <Route path="/voter-registration" element={<VoterRegistration />} />
          <Route path="/business-services" element={<BusinessServices />} />
          <Route path="/campaign-finance" element={<CampaignFinance />} />
          <Route path="/election-dashboards/:tab?" element={<ElectionData />} />
          <Route path="/past-election-results" element={<ElectionResults />} />
          <Route path="/historical-comparisons" element={<HistoricalComparisons />} />
        </Routes>
      </main>
    </BrowserRouter>
    );
}

export default App;